// extracted by mini-css-extract-plugin
module.exports = {"main":"ChatListLayout_main__3AN-6"};